
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

import StoryblokImage from '~/components/StoryblokImage.vue'
import storyblok from '~/mixins/storyblok'

const defaults = Object.freeze({
  surname: '',
  name: '',
  shop: '',
  activity: '',
  ville: '',
  quartier: '',
  siret: '',
  mail: '',
  phone: ''
})

export default {
  name: 'DevenirPartenaire',
  components: { StoryblokImage },
  mixins: [storyblok, validationMixin],
  async asyncData({ $db, $storyblok, error, params }) {
    const story = await $storyblok.getStoryBySlug('devenir-partenaire')
    return { story }
  },
  data: () => ({
    ...defaults,
    done: false
  }),
  validations: Object.keys(defaults).reduce((acc, key) => {
    acc[key] = { required }
    return acc
  }, {}),
  computed: {
    id() {
      return this.story.id
    },
    title() {
      return this.story.title
    },
    heroPicture() {
      return this.story.heroPicture
    },
    grid() {
      return this.story.grid
    }
  },
  mounted() {
    this.listenStoryblokChanges(this.id, (event) => {
      const { title, heroPicture, grid } = event.story.content
      this.title = title
      this.heroPicture = heroPicture
      this.grid = grid
    })
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
        )
        .join('&')
    },
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      const { story, done, ...formData } = this.$data
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: this.encode({ 'form-name': 'devenir-partenaire', ...formData })
      })
        .then(() => {
          this.resetData()
          this.done = true
        })
        .catch(() => {
          alert(
            'Une erreur est survenue veuillez remplir le formulaire une nouvelle fois'
          )
          this.resetData()
        })
    },
    resetData() {
      Object.keys(defaults).forEach((key) => {
        this.$data[key] = defaults[key]
      })
    }
  }
}
